import { render, staticRenderFns } from "./AccidentVehicle.vue?vue&type=template&id=700dcb0e&"
import script from "./AccidentVehicle.vue?vue&type=script&lang=js&"
export * from "./AccidentVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports